<template>
	<div style="height: 100%;">
		<TryRead :fatherId="fatherid" :tryReadId="tryReadId" :firstChildId="firstchildId" :InformationId="InformationId" :sellWay="sellway" :isIndex="isIndex" />
	</div>
</template>

<script>
import TryRead from '../../components/TryRead.vue'
export default{
	name: 'BookTryRead',
	data(){
		return{
			sellway:undefined,  // 试读页数
			tryReadId:undefined,  // 情报内容id
			InformationId:undefined,  // 情报id
			fatherid:undefined,  // 章的id
			firstchildId:undefined,  // 章的第一节id
			isIndex: false
		}
	},
	created() {
		// 获取参数
		this.isIndex = this.$route.query.isIndex;
		this.tryReadId = this.$route.query.id - 0;
		this.InformationId = this.$route.query.InformationId - 0;
		this.sellway = this.$route.query.sellway - 0;
		this.fatherid = this.$route.query.fatherId - 0;
		this.firstchildId = this.$route.query.firstchildId - 0;
	},
	components:{
		TryRead
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/BookDetails/BookTryRead.vue